import * as React from "react"

import { ReactComponent as LockSvg } from 'resources/icons/general/lock_pt1.svg'
import { ReactComponent as CommentSvg } from 'resources/icons/comment/comment_pt1.svg'
import { ReactComponent as ActionSvg } from 'resources/icons/general/action_pt1.svg'
import { ReactComponent as ControlsSvg } from 'resources/icons/general/controls_pt1.svg'

import IconBlock from '../c/IconBlock/IconBlock'

import * as st from './CommunicationChannels.styled.js'

const CommunicationChannels = () => (
  <st.Wrap>
    <st.Content>
      <st.Title>Communication channels</st.Title>
      <st.SectionsWrap>
        <st.Section>
          <st.Heading>
            <img
              src="//cdn-platform.scope-dev.ws/website/images/logos/slack-40.png"
              srcSet="//cdn-platform.scope-dev.ws/website/images/logos/slack-40.png 1x, //cdn-platform.scope-dev.ws/website/images/logos/slack-40@2x.png 2x"
              width={40}
              height={40}
              alt="Slack"
            />
            Slack Connect
          </st.Heading>
          <st.ImageTextsWrap>
            <st.Image1
              src="//cdn-platform.scope-dev.ws/website/images/screens/index/channels/slack.webp"
              srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/channels/slack.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/channels/slack@2x.webp 2x"
              width={490}
              height={292}
            />
            <st.Texts>
              <p>Receive notifications, respond to messages, leave comments on activities in threads, and track project progress in auto-updated Slack canvases.</p>
              <p>Use Slack Connect to communicate effectively with customers in channels managed and updated by Scope.</p>
              <st.Section1Footer>
                <st.FooterItem>
                  <IconBlock Icon={LockSvg} />
                  <st.FooterTexts>
                    <strong>External and Internal Channels</strong>
                    <p>One channel is for customer chats, another is for internal messages and notifications</p>
                  </st.FooterTexts>
                </st.FooterItem>
                <st.FooterItem>
                  <IconBlock Icon={CommentSvg} />
                  <st.FooterTexts>
                    <strong>Chat everywhere</strong>
                    <p>All comment streams bidirectionally between Slack to Scope. Discuss tasks in threads</p>
                  </st.FooterTexts>
                </st.FooterItem>
              </st.Section1Footer>
            </st.Texts>
          </st.ImageTextsWrap>
        </st.Section>

        <st.Section>
          <st.Heading>
            <img
              src="//cdn-platform.scope-dev.ws/website/images/logos/gmail-40.png"
              srcSet="//cdn-platform.scope-dev.ws/website/images/logos/gmail-40.png 1x, //cdn-platform.scope-dev.ws/website/images/logos/gmail-40@2x.png 2x"
              width={40}
              height={40}
              alt="Emails"
            />
            Emails
          </st.Heading>
          <st.ImageTextsWrap>
            <st.Image2
              src="//cdn-platform.scope-dev.ws/website/images/screens/index/channels/email.webp"
              srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/channels/email.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/channels/email@2x.webp 2x"
              width={490}
              height={412}
            />
            <st.Texts>
              <p>Scope sends different types of email notifications and reminders, each specifically designed for quick actions or task activities. All notifications and reminders can be fully customized to match your needs.</p>
              <st.Section2Footer>
                <st.FooterItem>
                  <IconBlock Icon={ControlsSvg} />
                  <st.FooterTexts>
                    <strong>Customizable</strong>
                  </st.FooterTexts>
                </st.FooterItem>
                <st.FooterItem>
                  <IconBlock Icon={ActionSvg} />
                  <st.FooterTexts>
                    <strong>Actionable</strong>
                  </st.FooterTexts>
                </st.FooterItem>
              </st.Section2Footer>
            </st.Texts>
          </st.ImageTextsWrap>
        </st.Section>
      </st.SectionsWrap>
    </st.Content>
  </st.Wrap>
)

export default CommunicationChannels
